/* 🤖 this file was generated by svg-to-ts */
export const matIconAlignVerticalTop: {
  name: 'align-vertical-top';
  data: string;
} = {
  name: 'align-vertical-top',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M22 2v2H2V2h20zM7 22h3V6H7v16zm7-6h3V6h-3v10z"/></svg>`
};
